

/**
 * @class
 * User model
 */
export default class User {

    /**
     * @constructor
     * @param {String} email User email
     * @param {String} password User password
     * @param {String} username User name
     * @param {Object} credentials User credentials
     */
    constructor(
      email,
      password,
      username,
      credentials,
    ){ 
      this._email = email
      this._password = password
      this._username = username
      this._credentials = credentials
    }

    get email(){
      return this._email
    }
    set email(email){
      this._email = email
    }

    get password(){
      return this._password
    }
    set password(password){
      this._password = password
    }

    get username(){
      return this._username
    }
    set username(username){
      this._username = username
    }

    get credentials(){
      return this._credentials
    }
    set credentials(credentials){
      this._credentials = credentials
    }

  }